import { render, staticRenderFns } from "./DetailGallery.vue?vue&type=template&id=6be4439d&"
import script from "./DetailGallery.vue?vue&type=script&lang=js&"
export * from "./DetailGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports